import * as Yup from 'yup'

export const Validation = Yup.object().shape({
  name: Yup.string()
    .max(50, 'Project name is too long')
    .required('Project name is required'),
})
